import React from 'react';
import { Link } from 'react-router-dom';

import '../../../style/layout/form/DashboardButton.css';

/**
 * A tool on the front page as an upright card: a photo filling the card (a green background
 * with the icon until there is one), the name and what it is for at the bottom. A tool of
 * another application (external) opens its address and shows an arrow.
 */
export default ({
  description,
  external,
  id,
  image,
  link,
  photo,
  value,
}: {
  description?: string;
  external?: boolean;
  id: string;
  image: string;
  link: string;
  // The photo of the card, e.g. an imported jpg; the icon on a green background without it
  photo?: string;
  value: string;
}): JSX.Element => {
  const content = (
    <>
      {photo ? (
        <span
          className="dashboard-card-photo"
          style={{ backgroundImage: `url(${photo})` }}
        />
      ) : null}
      <span className="dashboard-card-shade" />
      <span className="dashboard-card-icon">
        <img className="dashboard-image" src={image} alt="" id={id} />
      </span>
      <span className="dashboard-card-text">
        <span className="dashboard-text">
          {value}
          {external ? (
            <span aria-hidden="true" className="dashboard-external">
              ↗
            </span>
          ) : null}
        </span>
        {description ? (
          <span className="dashboard-description">{description}</span>
        ) : null}
      </span>
    </>
  );

  const className = `dashboard-link dashboard-card${
    photo ? ' with-photo' : ''
  }`;

  return external ? (
    <a href={link} className={className}>
      {content}
    </a>
  ) : (
    <Link to={link} className={className}>
      {content}
    </Link>
  );
};
